import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import {
  BackgroundIcon,
  getTranslatedText,
  DeleteModal,
  INVOICE_STATUS,
  DisabledTag,
  StatusTag,
  ERROR_CODES
} from '@nile/components';
import { ERROR_CODES_ITEM_MAP } from '@nile/client_management/src/Constants/invoice';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Tooltip } from 'react-clone-tippy';

const getErrorMessage = (col, intl) => {
  const { pushPaymentToIntegratedAppError, pushedToIntegratedAppError } = col;
  let errors = [];
  if (pushedToIntegratedAppError) errors = [...pushedToIntegratedAppError];
  if (pushPaymentToIntegratedAppError)
    errors = [...errors, ...pushPaymentToIntegratedAppError];

  return errors.reduce((acc, error) => {
    let items = '';

    if (error.params) {
      const itemsArray =
        error.params[ERROR_CODES_ITEM_MAP[error.errorCode]] ||
        error.params.items ||
        [];
      const itemStrings = itemsArray.map((item) => `${item.name}`);
      items = `(${itemStrings.join(', ')})`;
    }

    return `${acc}${getTranslatedText(
      intl,
      ERROR_CODES[error.errorCode] || error.message || ' '
    )} ${items}\n`;
  }, '');
};

/**
 * Cells are specific to the components using the table.
 * This action cell is used to push the invoice to third party.
 */

function InvoiceStatusCell(props) {
  const { cell, intl, statusObj } = props;
  const meta = cell?.row?.original;
  const statusObject = statusObj
    ? statusObj[cell.value]
    : INVOICE_STATUS[cell.value];
  const displayValue = statusObject
    ? getTranslatedText(intl, statusObject.label)
    : 'NA';

  // const showError = cell?.column?.showError;
  // const error = getErrorMessage(meta, intl);

  return statusObject ? (
    <div className="flex center">
      <StatusTag className="mw-100" statusObject={statusObject}>
        <div className="ellipsis" title={displayValue}>
          {displayValue}
        </div>
      </StatusTag>
      {/* {statusObject.errorMessage && (
        <div className="mlauto ml-10">
          <Tooltip
            distance={10}
            html={
              <span className="ws-prewrap">
                <FormattedMessage id={statusObject.errorMessage} />
              </span>
            }
            position="top-start"
            inertia
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
            className="tooltip"
          >
            <BackgroundIcon
              url={`url(${envConfig.imageRoot}svg/inline-error.svg)`}
              height="16px"
              width="16px"
            />
          </Tooltip>
        </div>
      )} */}
    </div>
  ) : (
    <DisabledTag>{displayValue}</DisabledTag>
  );
}

export default injectIntl(InvoiceStatusCell);
